var _circle, _circle2, _circle3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 39.5,
    fill: "#F2F5F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 39.5,
    stroke: "#003C8A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 39.5,
    stroke: "white",
    strokeOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9711 25.6167C46.842 24.0944 44.1675 23.3333 40.9477 23.3333C38.4992 23.3333 36.4317 23.8685 34.7527 24.9407C32.0875 26.6186 30.6718 29.4687 30.5 33.4874H36.6763C36.6763 32.3152 37.0219 31.191 37.7092 30.1021C38.3983 29.0169 39.5675 28.4742 41.2166 28.4742C42.8938 28.4742 44.0498 28.915 44.6792 29.7947C45.3124 30.678 45.628 31.654 45.628 32.7244C45.628 33.6578 45.1574 34.5116 44.5877 35.2857C44.2483 35.7662 43.8311 36.188 43.3532 36.5339C43.3532 36.5339 40.0045 38.6636 38.5347 40.3748C37.683 41.3656 37.6064 42.8527 37.5299 44.9824C37.5261 45.1343 37.584 45.4491 38.1182 45.4491H42.9199C43.398 45.4491 43.497 45.0991 43.5026 44.9417C43.5362 44.1676 43.6221 43.7694 43.766 43.3212C44.0349 42.4749 44.7708 41.7378 45.5944 41.1008L47.294 39.9396C48.8292 38.7525 50.0525 37.7802 50.5941 37.0172C51.5167 35.7653 52.1667 34.2208 52.1667 32.3874C52.1648 29.3965 51.1002 27.1427 48.9711 25.6167ZM40.8487 49.1196C38.7214 49.0548 36.9658 50.516 36.8986 52.805C36.8332 55.0903 38.501 56.6033 40.6302 56.6644C42.8508 56.7293 44.5597 55.3181 44.6288 53.0291C44.6923 50.7401 43.0712 49.1845 40.8487 49.1196Z",
    fill: "#003C8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.23945394d9dc893935db03fee31e1a01.svg";
export { ForwardRef as ReactComponent };